import { ContentBox } from 'app/agriculture/components/ContentBox/ContentBox';
import { SimpleGrid } from 'app/agriculture/components/SimpleGrid/SimpleGrid';
import { TrailCamImageBox } from 'app/agriculture/components/Image/TrailCamImageBox';
import { StatDisplay } from 'app/agriculture/components/StatDisplay/StatDisplay';
import { DeviceIcon } from 'app/agriculture/icons/devices/DeviceIcon';
import { StatHealth } from 'app/agriculture/components/StatHealth/StatHealth';
import { BatteryStat } from 'app/agriculture/components/BatteryStat/BatteryStat';
import { DeviceDetailsContent } from 'app/agriculture/routes/Devices/DeviceDetails/components/content/DeviceDetailsContent';
import { useContext } from 'react';
import { DeviceDetailContext } from 'app/agriculture/routes/Devices/DeviceDetails/context/DeviceDetailContextProvider';
import { DeviceOffline } from 'app/agriculture/routes/Devices/DeviceDetails/components/content/offline/DeviceOffline';
import { CircleIcon } from 'app/agriculture/icons';
import { SuspenseWrapper } from 'app/agriculture/components/SuspenseWrapper/SuspenseWrapper';
import { DeviceStatusProvider } from 'app/agriculture/routes/Devices/utils/status/DeviceStatusContext';
import { FixedLocationStat } from 'app/agriculture/components/FixedLocationStat/FixedLocationStat';
import { Skeleton } from '@mui/material';
import { useFarm } from 'app/agriculture/hooks/useFarm/useFarm';
import { Chip } from 'app/agriculture/infobox/common/Chip/Chip';
import { DeviceActions } from 'app/agriculture/routes/Devices/components/DeviceActions';
import { BatteryStatSkeleton } from 'app/agriculture/components/BatteryStat/BatteryStatSkeleton';
import { DeviceShowOnMapButton } from 'app/agriculture/routes/Devices/DeviceDetails/components/DeviceShowOnMapButton';

export function DeviceDetailsComponent() {
    const { device } = useContext(DeviceDetailContext);
    const { farm } = useFarm();
    const isDefaultWeatherStation = farm.weatherStation === device.id;

    const { name, brand, deviceType, locationOverride } = device;

    return (
        <ContentBox
            className="DeviceDetailsComponent"
            title={name}
            variant="xl"
            Icon={(props) => <DeviceIcon {...props} deviceType={deviceType} />}
            showOnMapButton={
                <SuspenseWrapper loadingComponent={null}>
                    <DeviceShowOnMapButton deviceId={device.id} />
                </SuspenseWrapper>
            }
            aside={
                <SuspenseWrapper>
                    <TrailCamImageBox />
                </SuspenseWrapper>
            }
            headerContent={
                !isDefaultWeatherStation ? null : <Chip text="Default" variant="outline" />
            }
        >
            <ContentBox.Section scrollable disableDivider>
                <ContentBox.Section disableDivider>
                    <SimpleGrid columns={3}>
                        <StatDisplay
                            id="device-type"
                            name="Type"
                            Icon={(props) => <DeviceIcon {...props} deviceType={deviceType} />}
                            value={deviceType}
                        />
                        <SuspenseWrapper
                            loadingComponent={
                                <StatDisplay
                                    name="Status"
                                    Icon={(props) => (
                                        <CircleIcon {...props} size={10} color="grey" />
                                    )}
                                    value={<Skeleton variant="text" width={50} />}
                                />
                            }
                        >
                            <DeviceStatusProvider deviceId={device.id}>
                                <StatHealth />
                            </DeviceStatusProvider>
                        </SuspenseWrapper>

                        {brand === 'Yarn' ? (
                            <SuspenseWrapper
                                loadingComponent={<BatteryStatSkeleton name="Battery" />}
                            >
                                <BatteryStat name="Battery" deviceId={device.id} />
                            </SuspenseWrapper>
                        ) : null}

                        {deviceType !== 'Level Monitor' ? (
                            <FixedLocationStat
                                name="Location Source"
                                usingLocationOverride={!!locationOverride}
                            />
                        ) : null}
                    </SimpleGrid>
                </ContentBox.Section>
                <DeviceOffline />
                <DeviceDetailsContent />
                <DeviceActions sticky deviceId={device.id} />
            </ContentBox.Section>
        </ContentBox>
    );
}
